import { Alert, Snackbar } from "@mui/material";

function SnackSuccess({alterMessage, setAlertMessage, snackMessage}){
    return (
    <Snackbar
        open={alterMessage}
        autoHideDuration={3000}
        data-testid="cb-success-snackbar"
        onClose={() => {
          setAlertMessage(false);
        }}
      >
        <Alert severity="success"> {snackMessage}</Alert>
      </Snackbar>
    )
}

export default SnackSuccess